import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material'
import {
  preventKeys,
  preventPasteKeys,
} from '@planning/pages/VesselVisit/Components/atoms/NumberFieldWithUnit'
import { useTranslate } from '@tolgee/react'
import { FC, useCallback, useState } from 'react'
import { RailcarPlanningViewStore } from '../../Stores/RailcarPlanningViewStore'

type Props = {
  railcarPlanningViewStore: RailcarPlanningViewStore
  railVisitId: number
  railTrackId: string
  railcarTrackPositionId: number
  open: boolean
  onClose: () => void
}

export const RailcarPlanningChangeSequenceNumberDialog: FC<Props> = props => {
  const {
    open,
    railcarPlanningViewStore,
    railVisitId,
    railTrackId,
    railcarTrackPositionId,
    onClose,
  } = props
  const { t } = useTranslate()

  const [sequenceNumber, setSequenceNumber] = useState<number | null>(null)

  const closeModal = useCallback(() => {
    setSequenceNumber(null)
    onClose()
  }, [onClose])

  const onChange = useCallback(() => {
    const finalSequenceNumber = sequenceNumber !== null && sequenceNumber > 0 ? sequenceNumber : 1

    railcarPlanningViewStore.updateSequence(
      railVisitId,
      railTrackId,
      railcarTrackPositionId,
      finalSequenceNumber,
    )
    closeModal()
  }, [
    sequenceNumber,
    railcarPlanningViewStore,
    railVisitId,
    railTrackId,
    railcarTrackPositionId,
    closeModal,
  ])

  const onCancel = useCallback(() => closeModal(), [closeModal])

  const railcarSequenceMax = 350

  return (
    <Dialog open={open} fullWidth maxWidth='xs'>
      <DialogTitle>{t('changeSequenceNo', 'Change sequence no.')}</DialogTitle>
      <DialogContent sx={{ overflow: 'visible' }}>
        <Stack spacing={2} pt={1}>
          <TextField
            autoFocus
            label={t('newSequenceNo', 'New sequence no.')}
            type='number'
            fullWidth
            value={sequenceNumber ?? ''}
            slotProps={{ htmlInput: { min: 1, max: railcarSequenceMax } }}
            onChange={e => {
              const inputSequenceNumber = e.target.value ? Number(e.target.value) : undefined
              if (!inputSequenceNumber) return

              const effectiveSequenceNumber = Math.min(inputSequenceNumber, railcarSequenceMax)
              setSequenceNumber(effectiveSequenceNumber)
            }}
            onKeyDown={e => preventKeys(e, 'nonNegative')}
            onPaste={e => preventPasteKeys(e, 'nonNegative')}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onChange} variant='contained' color='primary'>
          {t('change', 'Change')}
        </Button>
        <Button onClick={onCancel} color='inherit'>
          {t('cancel', 'Cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
